import SeasonSettingsProvider from "./season-settings-provider";
import GamedayApiService from "../gameday-api-service";

class GamedaySeasonSettingsProvider extends SeasonSettingsProvider {
    async getSettings(seasonId) {
        return GamedayApiService.getSeasonSettings(seasonId);
    }

    async saveSettings(seasonId, settings) {
        await GamedayApiService.saveSeasonSettings(seasonId, settings);
    }
}

export default GamedaySeasonSettingsProvider;
